/**
 * @generated SignedSource<<060507cc19c856be16a6c851e122e50d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraVersionDetailsCollapsedUi = "DESCRIPTION" | "ISSUES" | "ISSUE_ASSOCIATED_DESIGNS" | "PROGRESS_CARD" | "RELATED_WORK" | "RICH_TEXT_SECTION" | "RIGHT_SIDEBAR" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type rightSidebar_softwareReleasesVersionDetail$data = {
  readonly collapsedUis: ReadonlyArray<JiraVersionDetailsCollapsedUi | null | undefined> | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "rightSidebar_softwareReleasesVersionDetail";
};
export type rightSidebar_softwareReleasesVersionDetail$key = {
  readonly " $data"?: rightSidebar_softwareReleasesVersionDetail$data;
  readonly " $fragmentSpreads": FragmentRefs<"rightSidebar_softwareReleasesVersionDetail">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "rightSidebar_softwareReleasesVersionDetail",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "collapsedUis"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "f6b47df507b4f1c932a991a3cdcfb952";

export default node;
